<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <span
          id="valorVencido7DiasId"
          :style="styleObjectInadimplente"
        >
          {{ valorTituloVencidos }}
        </span>
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Nome reduzido
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Qtd lançamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Vencido em aberto
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Dias vencido
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dadosTituloVencidosSeteDias"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_reduzido }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  {{ item.qtd_lancamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.valor_aberto }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  {{ item.dias_vencido }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowSaldoTotal',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectInadimplente: {
        color: '#f27686',
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectClientes: [],
      valorTituloVencidos: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      headersVencidosSeteDias: [
        { text: 'Nome reduzido', value: 'nome_reduzido', class: 'black--text title' },
        { text: 'Qtd lançamento', value: 'qtd_lancamento', align: 'right', class: 'black--text title' },
        { text: 'Vencido em aberto', value: 'valor_aberto', align: 'right', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', align: 'right', class: 'black--text title' },
      ],
      dadosTituloVencidosSeteDias: [],
    }),

    created () {
      eventEmit.$on('set-acompanhamento-diario', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-acompanhamento-diario', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, texto, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectClientes = selectClientes

        this.showContasValorTituloVencidos()
      },

      async showContasValorTituloVencidos () {
        this.loading = true
        this.valorTituloVencidos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.dadosTituloVencidosSeteDias = []

        await ContasReceber.showValorTituloVencidos(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorTituloVencidos = parseFloat(resposta.data.valorTituloVencido).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.dadosTituloVencidosSeteDias = resposta.data.dados.map((item) => {
              var listaTitulosVencidos = ({
                nome_reduzido: item.nome_reduzido,
                qtd_lancamento: item.qtd_lancamento,
                valor_aberto: parseFloat(item.valor_aberto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                dias_vencido: item.dias_vencido,
              })

              return listaTitulosVencidos
            })
          } else if (resposta.data.msg === 'Não há títulos vencidos nos ultimos 7 dias') {
            this.valorTituloVencidos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.dadosTituloVencidosSeteDias = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #valorVencido7DiasId {
      margin: -0.5rem 0 0 11rem;
      font-size: 20px;
    }

    #idTable {
      max-height: 450px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #valorVencido7DiasId {
      margin: -3rem 0 0 21rem !important;
      font-size: 20 !important;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 445px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #valorVencido7DiasId {
    font-size: 24px;
    display: grid;
    align-items: center;
    margin: -0.1rem 5rem 0 8.5rem;
    font-weight: bold;
  }
</style>
